import { render, staticRenderFns } from "./syspam.vue?vue&type=template&id=4c02ad18&"
import script from "./syspam.vue?vue&type=script&lang=js&"
export * from "./syspam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports